import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { AuthService } from '@shared-services/auth.service'
import { permissionGuard } from './permission.guard'

export const accessManagementGuard: CanActivateFn = (route, state) => {
  const path = state.url.split('?')[0].split('#')[0]

  if (
    (path === '/gestion-accesos' || path === '/gestion-accesos/usuarios')
    && inject(AuthService).hasRole('SUPER_ADMIN')
  ) {
    return true
  }

  return permissionGuard(route, state)
}
